<template>
    <div class="p-2">
        <div class="form-group">
            <label for="zoom" class="form-control-label mb-0">{{ trans('Mode') }}:</label>
            <v-select
                :placeholder="trans('Select...')"
                id="zoom_id"
                label="text"
                :options="zoomOptions"
                :modelValue="filters.zoom"
                @update:modelValue="filters.zoom = $event"
                :reduce="(zoom) => zoom.id"
            >
            </v-select>
        </div>
        <div class="form-group">
            <label for="amount_id" class="form-control-label mb-0">{{ trans('Amount') }}:</label>
            <v-select
                :placeholder="trans('Select...')"
                id="amount_id"
                label="text"
                :options="zoomAmountOptions"
                :modelValue="filters.amount"
                @update:modelValue="filters.amount = $event"
            >
            </v-select>
        </div>
        <div class="form-group">
            <label for="from_date" class="form-control-label mb-0">{{ trans('Date') }}:</label>
            <vue-flatpickr
                :modelValue="filters.date"
                @update:modelValue="filters.date = $event"
                :config="{
                    allowInput: true,
                    dateFormat: 'Y-m-d',
                    altInput: true,
                    altFormat: 'd/m/Y',
                }"
                :placeholder="trans('Select date')"
                class="form-control"
                name="from_date"
                autocomplete="off"
            >
            </vue-flatpickr>
        </div>
        <div v-if="planningType !== 'capacity'" class="form-group">
            <label for="status_id" class="form-control-label mb-0">{{ trans('Status') }}:</label>
            <v-select
                :placeholder="trans('Select...')"
                id="status_id"
                label="title"
                :options="taskStatuses"
                :reduce="(status) => status.id"
                :modelValue="filters.statuses"
                @update:modelValue="filters.statuses = $event"
                multiple
            >
                <template v-slot:option="option">
                    <div class="d-center">
                        <span
                            class="badge"
                            :style="'background-color:' + option.color + '; color: #fff;'"
                        >
                            {{ option.title }}
                        </span>
                    </div>
                </template>
                <template v-slot:selected-option="option">
                    <div class="selected d-center">
                        <span
                            class="badge"
                            :style="'background-color:' + option.color + '; color: #fff;'"
                        >
                            {{ option.title }}
                        </span>
                    </div>
                </template>
            </v-select>
        </div>
        <!--        <div class="form-group" v-if="mode === 'project'">-->
        <!--            <label for="planned" class="form-control-label mb-0">{{ trans('Planned') }}: </label>-->
        <!--            <v-select :placeholder="trans('Select...')" id="planned_project_id" label="text">-->
        <!--            </v-select>-->
        <!--        </div>-->
        <!--        <div class="form-group" v-if="mode === 'person'">-->
        <!--            <label for="planned" class="form-control-label mb-0">{{ trans('Planned') }}: </label>-->
        <!--            <v-select :placeholder="trans('Select...')" id="planned_person_id" label="text">-->
        <!--            </v-select>-->
        <!--        </div>-->
        <button class="btn btn-secondary" type="button" @click.stop="reset()">
            {{ trans('reset') }}
        </button>
        <button class="btn btn-primary ml-1" type="button" @click.stop="save()">
            {{ trans('filter') }}
        </button>
    </div>
</template>

<script>
import VueFlatpickr from 'vue-flatpickr-component';
import { mapActions, mapMutations, mapState } from 'vuex';
import { MODE, ZOOM_LEVEL, ZOOM_SETTINGS } from '../../../constants';
import { DateTimeFormatter, LocalDate } from '@js-joda/core';

const dateformatter = DateTimeFormatter.ofPattern('yyyy-MM-dd');

export default {
    components: {
        VueFlatpickr,
    },
    data() {
        return {
            dateFormat: 'dd-mm-yyyy',
            filters: {
                zoom: null,
                amount: null,
                date: null,
                statuses: [],
            },
            taskStatuses: [],
        };
    },
    methods: {
        ...mapMutations('planning', [
            'setCurrentAmountToShow',
            'setCurrentZoom',
            'setStatusesToShow',
        ]),
        ...mapActions('planning', ['resetCalendar']),
        save() {
            this.setCurrentZoom(this.filters.zoom);
            this.setCurrentAmountToShow(this.filters.amount);
            this.setStatusesToShow(this.filters.statuses);

            var queryParams = new URLSearchParams(window.location.search);
            queryParams.set('date', this.filters.date);
            history.pushState(null, null, '?' + queryParams.toString());

            this.resetCalendar();
        },
        reset() {
            let date = LocalDate.now();
            this.filters = {
                zoom: this.currentZoom,
                amount: ZOOM_SETTINGS[this.currentZoom].amountToShow,
                date: date.format(dateformatter),
                statuses: [],
            };
            this.save();
        },
        getTaskStatuses() {
            let url = route('task.get-task-statuses');

            axios.get(url).then((response) => {
                this.taskStatuses = response.data.taskStatuses;
            });
        },
    },
    computed: {
        ...mapState('planning', [
            'mode',
            'currentZoom',
            'currentAmountToShow',
            'dateToShow',
            'statusesToShow',
        ]),
        planningType() {
            return MODE[this.mode].type;
        },

        zoomOptions() {
            let zoomOpions = [
                {
                    id: ZOOM_LEVEL.week,
                    text: trans('Week'),
                },
                {
                    id: ZOOM_LEVEL.month,
                    text: trans('Month'),
                },
            ];

            if (this.planningType !== 'capacity') {
                zoomOpions.unshift({
                    id: ZOOM_LEVEL.day,
                    text: trans('Day'),
                });
            }
            return zoomOpions;
        },
        zoomAmountOptions() {
            let items = [];

            switch (this.filters.zoom) {
                case ZOOM_LEVEL.day:
                    items = items = Array.from({ length: 14 }, (_, index) => index + 1);
                    break;
                case ZOOM_LEVEL.week:
                    items = items = Array.from({ length: 12 }, (_, index) => index + 1);
                    break;
                case ZOOM_LEVEL.month:
                    items = items = Array.from({ length: 12 }, (_, index) => index + 1);
                    break;
            }

            return items;
        },
    },
    created() {
        this.getTaskStatuses();
        this.filters = {
            zoom: this.currentZoom,
            amount: this.currentAmountToShow,
            date: this.dateToShow.format(dateformatter),
            statuses: this.statusesToShow,
        };
    },
};
</script>

<style scoped></style>
